import { useCallback } from "react";
import { createPortal } from "react-dom";

import { isBrowser } from "~/utils/helpers";

import { Toast } from "./Toast";
import { useToasts } from "./useToasts";
import { Button } from "../button/Button";
import { Text } from "../text/Text";

export interface ToastStackProps {
  insetBottom?: string;
  position?: "start" | "end" | "center";
}

export function ToastStack({ insetBottom, position }: ToastStackProps) {
  const { toasts, dismissToast } = useToasts();

  const handleDismiss = useCallback(
    (id: string) => {
      dismissToast(id);
    },
    [dismissToast],
  );

  const customProperties = {
    "--toast-stack-inset-bottom": insetBottom,
  };

  return isBrowser() && toasts.length
    ? createPortal(
        <div
          className="ToastStack"
          style={customProperties}
          data-position={position}
        >
          {toasts.map((t) => {
            const shouldRenderButton = Boolean(t.actionText && t.onActionClick);

            function renderButton() {
              return (
                <Button
                  appearance="minimal"
                  size="sm"
                  invert
                  onClick={t.onActionClick}
                >
                  <Text size="sm" weight="semibold">
                    {t.actionText}
                  </Text>
                </Button>
              );
            }

            return (
              <Toast
                description={t.description}
                dismissable={t.dismissable}
                icon={t.icon}
                iconVariant={t.iconVariant}
                id={t.id}
                intent={t.intent}
                key={t.id}
                title={t.title}
                renderButton={shouldRenderButton ? renderButton : undefined}
                onDismiss={handleDismiss}
              />
            );
          })}
        </div>,
        document.body,
      )
    : null;
}
